import firebase from "firebase";
import "firebase/firestore";
import "firebase/performance";
import 'firebase/auth';
import 'firebase/messaging';
import "firebase/analytics";
import 'firebase/firebase-analytics';

const firebaseConfig = {
  apiKey: process.env.VUE_APP_FIREBASE_API_KEY,
  authDomain: process.env.VUE_APP_FIREBASE_DOMAIN,
  databaseURL: process.env.VUE_APP_FIREBASE_DBURL,
  projectId: process.env.VUE_APP_FIREBASE_PID,
  storageBucket: process.env.VUE_APP_FIREBASE_SBUCKET,
  messagingSenderId: process.env.VUE_APP_FIREBASE_MSID,
  appId: process.env.VUE_APP_FIREBASE_APPID,
  measurementId: "G-DETS3GE7QQ"
};

const fire = firebase.initializeApp(firebaseConfig);
firebase.analytics();
const analytics = firebase.analytics();
firebase.performance();
if (firebase.messaging.isSupported()) {
  // console.log("soportado");
  firebase.messaging();
} else {
  console.log("no soportado");
}
// const messaging = firebase.messaging();
export default fire;
